import { AllModules } from '@ag-grid-enterprise/all-modules';
import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AnalyticsEntry } from 'app/api/analytics.api.service';
import { CompanySubset } from 'app/api/company.api.service';
import { AppState } from 'app/reducers';
import { Observable } from 'rxjs';

import { AnalyticsSelectors } from 'app/main/analytics/selectors';

export interface AnaTreeRow extends AnalyticsEntry {
    path: string;
}

@Component({
    selector: 'app-analytics-tree',
    templateUrl: './analytics-tree.component.html',
    styleUrls: ['./analytics-tree.component.scss']
})
export class AnalyticsTreeComponent implements OnInit {
    @Input() company: CompanySubset;

    private anaGridApi;
    private anaGridColumnApi;
    private groupGridApi;
    private groupGridColumnApi;

    public modules = AllModules;

    public anaParams = {
        getRowNodeId: null,
        getDataPath: null,
        columnDefs: null,
        groupDefaultExpanded: null,
        autoGroupColumnDef: null,
    };
    public groupParams = {
        getRowNodeId: null,
        getDataPath: null,
        columnDefs: null,
        groupDefaultExpanded: null,
        autoGroupColumnDef: null,
    };

    anaData$: Observable<AnaTreeRow[]>;
    groupData$: Observable<AnaTreeRow[]>;

    constructor(protected store: Store<AppState>) {

        this.anaParams.getRowNodeId = data => data.path;
        this.anaParams.getDataPath = data => data.path.split('#');
        this.anaParams.columnDefs = [];
        this.anaParams.groupDefaultExpanded = -1;
        this.anaParams.autoGroupColumnDef = {
            headerName: 'Axes Analytiques',
            valueGetter: params => params.data && params.data.name,
            cellRendererParams: { suppressCount: true },
            suppressMenu: true
        };

        this.groupParams.getRowNodeId = data => data.path;
        this.groupParams.getDataPath = data => data.path.split('#');
        this.groupParams.columnDefs = [];
        this.groupParams.groupDefaultExpanded = -1;
        this.groupParams.autoGroupColumnDef = {
            headerName: 'Ventilation par Groupes',
            cellClass: params => params.data && params.data.color,
            valueGetter: params => params.data && params.data.name,
            cellRendererParams: { suppressCount: true },
            suppressMenu: true
        };

    }

    ngOnInit(): void {
        this.anaData$ = this.store.pipe(select(AnalyticsSelectors.selectAnalyticsTree));
        this.groupData$ = this.store.pipe(select(AnalyticsSelectors.selectAnalyticsTreeGroups2));
    }

    onFilterTextBoxChanged(): void {
        const value = (document.getElementById('filter-text-box') as HTMLInputElement).value;
        this.anaGridApi.setQuickFilter(value);
        this.groupGridApi.setQuickFilter(value);
    }

    onAnaGridReady(params): void {
        this.anaGridApi = params.api;
        this.anaGridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    onGroupGridReady(params): void {
        this.groupGridApi = params.api;
        this.groupGridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

}
